const defaultSampleHelper = `module.exports = {
    tenantName : '{tenant-id}'
}`;

export default defaultSampleHelper;
